export const themes = {
  default: () => ({
    thRoot: 'flex max-w-full flex-col',
    thBannerRoot: 'max-w-full',
    thBannerHtml: '',
    thBannerImg: 'max-w-full',
    thBannerText: '',
  }),
  top: () => ({
    thRoot: 'flex max-w-full flex-col justify-center items-center',
    thBannerRoot: 'max-w-full',
    thBannerHtml: '',
    thBannerImg: 'max-w-full',
    thBannerText: '',
  }),
  terms: () => ({
    thRoot: 'flex max-w-full flex-col text-grey',
    thBannerRoot: 'max-w-full',
    thBannerHtml: 'leading-normal text-sm text-gray-medium',
    thBannerImg: 'max-w-full',
    thBannerText: 'leading-normal text-sm text-gray-medium',
  }),
};
